import React, { useEffect, useState } from 'react';
import { Container } from '@infoods/lifebase-ui';

import { observer } from 'mobx-react';

import { angularizeWithProviders } from '../../../../shared/providers';
import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
import { entityInfoService } from '../../../../entity-management';
import { ChallengePayment } from '../../entity-profile/ChallengePayment/ChallengePayment';

const NgzChallengeSubscriptionPage = observer(() => {
  const entityId = loggedInUserDataStore.getEntityId();

  const [isStripeConnected, setIsStripeConnected] = useState(false);

  useEffect(() => {
    entityInfoService.getEntityAdminInfo().then((info) => {
      setIsStripeConnected(info.isStripeAccountConnected);
    });
  }, [entityId]);

  return (
    <Container>
      <ChallengePayment entityId={entityId} isStripeConnected={isStripeConnected} />
    </Container>
  );
});

angularizeWithProviders(NgzChallengeSubscriptionPage, 'ngzChallengeSubscriptionPage', {});

export { NgzChallengeSubscriptionPage };
